import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Namespace comum

// Feature namespaces

import enUsAccessControl from '@/features/access-control/i18n/en-US.json';
import ptBrAccessControl from '@/features/access-control/i18n/pt-BR.json';
import enUsAuth from '@/features/auth/i18n/en-US.json';
import ptBrAuth from '@/features/auth/i18n/pt-BR.json';
import enUsBanner from '@/features/banner-management/i18n/en-US.json';
import ptBrBanner from '@/features/banner-management/i18n/pt-BR.json';
import enUsClassModuleManagement from '@/features/class-module-management/i18n/en-US.json';
import ptBrClassModuleManagement from '@/features/class-module-management/i18n/pt-BR.json';
import ptBrClassPlanning from '@/features/class-planning/i18n/pt-BR.json';
import enUsExamCorrection from '@/features/exam-correction/i18n/en-US.json';
import ptBrExamCorrection from '@/features/exam-correction/i18n/pt-BR.json';
import enUsExamManagement from '@/features/exam-management/i18n/en-US.json';
import ptBrExamManagement from '@/features/exam-management/i18n/pt-BR.json';
import ptBrExamRevision from '@/features/exam-revision/i18n/pt-BR.json';
import ptBrGradeAttendanceConfig from '@/features/grade-attendance-config/i18n/pt-BR.json';
import enUsIndividualPayment from '@/features/individual-payment/i18n/en-US.json';
import ptBrIndividualPayment from '@/features/individual-payment/i18n/pt-BR.json';
import enUsLocation from '@/features/location/i18n/en-US.json';
import ptBrLocation from '@/features/location/i18n/pt-BR.json';
import ptBrNotification from '@/features/notification/i18n/pt-BR.json';
import enUsQuestionLibrary from '@/features/question-library/i18n/en-US.json';
import ptBrQuestionLibrary from '@/features/question-library/i18n/pt-BR.json';
import ptBrSeries from '@/features/series-management/i18n/pt-BR.json';
import ptBrSlideEditor from '@/features/slide-editor/i18n/pt-BR.json';
import enUsPersonManagement from '@/features/student-management/i18n/en-US.json';
import ptBrPersonManagement from '@/features/student-management/i18n/pt-BR.json';
import enUsTutorAI from '@/features/tutor-ai/i18n/en-US.json';
import ptBrTutorAI from '@/features/tutor-ai/i18n/pt-BR.json';
import enUsUserManagement from '@/features/user-management/i18n/en-US.json';
import ptBrUserManagement from '@/features/user-management/i18n/pt-BR.json';
import enUsCommon from '@/shared/i18n/locales/en-US/common.json';
import ptBrCommon from '@/shared/i18n/locales/pt-BR/common.json';

const defaultLocale = import.meta.env.VITE_I18N_DEFAULT_LOCALE ?? 'pt-BR';

void i18n.use(initReactI18next).init({
  lng: defaultLocale,
  fallbackLng: 'pt-BR',

  /**
   * Namespaces registrados.
   * Cada feature registra seu próprio namespace com o nome da feature em camelCase.
   */
  ns: [
    'common',
    'userManagement',
    'auth',
    'accessControl',
    'examCorrection',
    'examManagement',
    'notification',
    'questionLibrary',
    'slideEditor',
    'personManagement',
    'examRevision',
    'gradeAttendanceConfig',
    'classModuleManagement',
    'classPlanning',
    'location',
    'individualPayment',
    'tutorAI',
    'series',
    'banner',
  ],
  defaultNS: 'common',

  resources: {
    'pt-BR': {
      common: ptBrCommon,
      userManagement: ptBrUserManagement,
      auth: ptBrAuth,
      accessControl: ptBrAccessControl,
      examCorrection: ptBrExamCorrection,
      examManagement: ptBrExamManagement,
      notification: ptBrNotification,
      questionLibrary: ptBrQuestionLibrary,
      slideEditor: ptBrSlideEditor,
      personManagement: ptBrPersonManagement,
      examRevision: ptBrExamRevision,
      gradeAttendanceConfig: ptBrGradeAttendanceConfig,
      classModuleManagement: ptBrClassModuleManagement,
      classPlanning: ptBrClassPlanning,
      location: ptBrLocation,
      individualPayment: ptBrIndividualPayment,
      tutorAI: ptBrTutorAI,
      series: ptBrSeries,
      banner: ptBrBanner,
    },
    'en-US': {
      common: enUsCommon,
      userManagement: enUsUserManagement,
      auth: enUsAuth,
      accessControl: enUsAccessControl,
      examCorrection: enUsExamCorrection,
      examManagement: enUsExamManagement,
      // notification en-US not yet generated — run yarn translate:notification
      notification: ptBrNotification,
      questionLibrary: enUsQuestionLibrary,
      // slideEditor en-US not yet generated — run yarn translate:slideEditor
      slideEditor: ptBrSlideEditor,
      personManagement: enUsPersonManagement,
      // examRevision en-US not yet generated — run yarn translate:examRevision
      examRevision: ptBrExamRevision,
      // gradeAttendanceConfig en-US not yet generated — run yarn translate:gradeAttendanceConfig
      gradeAttendanceConfig: ptBrGradeAttendanceConfig,
      classModuleManagement: enUsClassModuleManagement,
      // classPlanning en-US not yet generated — run yarn translate:classPlanning
      classPlanning: ptBrClassPlanning,
      location: enUsLocation,
      individualPayment: enUsIndividualPayment,
      tutorAI: enUsTutorAI,
      // series en-US not yet generated — run yarn translate:series
      series: ptBrSeries,
      banner: enUsBanner,
    },
  },

  interpolation: {
    escapeValue: false,
  },

  parseMissingKeyHandler: (key, defaultValue) => {
    if (import.meta.env.DEV) {
      console.warn(`[i18n] Missing key: ${key}`);
    }
    return defaultValue ?? key;
  },
});

export default i18n;
